import messages from './messages';

export const EligibilityErrors = {
	b2b_partner_eligibility_redeem_invalid_id: messages.errorInvalidOfferCode,
	b2b_partner_eligibility_already_redeemed: messages.errorUsedOfferCode,
} as const;

type EligibilityErrorKey = keyof typeof EligibilityErrors;

export const isEligibilityErrorKey = (value: string): value is EligibilityErrorKey =>
	value in EligibilityErrors;
